import React from 'react';
import '../../styles/MetaSistema.css';
import socialData from '../../data/socialLinks.json';
import * as Icons from 'react-icons/fa6'; // Importa todos los iconos dinámicamente

const DigitalPlatforms = () => {
    return (
        <section className="digital-platforms-section">
            <div className='container'>
                {/* Título */}
                <div className="title-container" data-aos="fade-up" data-aos-offset="50">
                    <h2 className="title">Plataformas digitales</h2>
                    <div className="title-underline"></div>
                </div>

                <div className="section-description" data-aos="fade-up">
                    <p>
                        <span className="description-highlight">Integramos plataformas digitales con soluciones de contenido y publicidad</span> para amplificar el alcance de nuestros
                        anunciantes. Creamos experiencias que conectan con la audiencia adecuada y generan impacto en el ecosistema digital.
                    </p>
                </div>

                {/* Contenido principal */}
                <div className="row justify-content-center align-items-stretch">
                    {/* Primera columna */}
                    <div className="col-lg-5 d-flex p-3 platform-card m-3 text-center shadow-lg" data-aos="fade-right">
                        <div className="flex-fill">
                            <h3 className="platform-title p-3">Web / RRSS / Plataformas</h3>
                            <p className="platform-description">
                                La red de canales de difusión conecta con nuestro público en cada parte del ecosistema digital con la mayor relevancia.
                            </p>
                            <div className="platform-icons d-flex flex-wrap justify-content-center gap-3">
                                {socialData.map((social, index) => {
                                    const IconComponent = Icons[`Fa${social.name.charAt(0).toUpperCase() + social.name.slice(1)}`];
                                    return (
                                        <a key={index} href={social.link} target="_blank" rel="noopener noreferrer" className='d-flex justify-content-center align-items-center'>
                                            {IconComponent ? <IconComponent /> : null}
                                        </a>
                                    );
                                })}
                            </div>
                            <img src="assets/plataformas_digitales_desktop.png" alt="Plataforma digital" className="platform-image img-fluid mt-3 img-filter" data-aos="flip-right" />
                        </div>
                    </div>

                    {/* Segunda columna */}
                    <div className="col-lg-5 col-md-12 d-flex p-3 platform-card m-3 text-center shadow-lg" data-aos="fade-left">
                        <div className="flex-fill">
                            <h3 className="platform-title p-3">Contenido y Ads</h3>
                            <p className="platform-description">
                                Distribuimos contenido gráfico y audiovisual de alto impacto, además de ads y auspicios para amplificar la efectividad.
                            </p>
                            <ul className="platform-list">
                                <li><img src="assets/contenido_y_ads_1.png" alt="Video" className="platform-icon img-fluid img-filter" data-aos="zoom-out" /> Lives & webinars, cápsulas educativas, podcasts, videos / shorts.</li>
                                <li><img src="assets/contenido_y_ads_2.png" alt="Publicidad" className="platform-icon img-fluid img-filter" data-aos="zoom-out" /> Iniciativas, campañas de contenido editorial, reels & stories.</li>
                                <li><img src="assets/contenido_y_ads_3.png" alt="Micrositios" className="platform-icon img-fluid img-filter" data-aos="zoom-out" /> Desarrollo de micrositios + Contenido.</li>
                                <li><img src="assets/contenido_y_ads_4.png" alt="Publicidad programática" className="platform-icon img-fluid img-filter" data-aos="zoom-out" /> Publicidad programática con banners de display y video + amplificación orgánica y paid media en RRSS.</li>
                            </ul>
                            <img src="assets/plataformas_digitales_mobile.png" alt="Publicidad en móvil" className="platform-image img-fluid mt-3 img-filter" data-aos="flip-left" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default DigitalPlatforms;